import { agentStatusRender } from '@oneToOne/agentStatus/agentStatusRender'
import { AGENT_STATUS_ELEMENT_ID } from '@oneToOne/shared/components/chat/constants'

import { FWNElement } from './bases/FWNElement'

/**
 * The `AgentStatus` is a simple web component designed to
 * manage the availability of sales agents. It offers conditional rendering of
 * three slots that can be utilized to display user interfaces for loading,
 * available, and not-available states on a web page.
 *
 * To use the `AgentsAvailabilityWrapper` component, follow the example below:
 *
 * <fw-agent-status>
 *   <!-- Content for available state -->
 *   <button slot="available">Talk to me</button>
 *
 *   <!-- Content for loading state -->
 *   <button slot="loading" disabled="disabled">Loading...</button>
 *
 *   <!-- Content for not-available state -->
 *   <button slot="not-available" disabled="disabled">Sorry, everybody is sleeping</button>
 * </fw-agents-availability-wrapper>
 */
class AgentStatusElement extends FWNElement {
  override render(): void {
    if (this.shadowRoot) {
      agentStatusRender({
        target: this.shadowRoot,
        widgetId: this.widgetId,
        widgetAttributes: this.getAttributes(),
      })
    }
  }
}

declare module 'react' {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    interface IntrinsicElements {
      [AGENT_STATUS_ELEMENT_ID]: Record<string, string | boolean>
    }
  }
}

if (!customElements.get(AGENT_STATUS_ELEMENT_ID)) {
  customElements.define(AGENT_STATUS_ELEMENT_ID, AgentStatusElement)
}
